/**
 * <bh-charcount> — live "used / limit" counter for any capped text field.
 *
 * The cap itself is the field's native `maxlength`, so the browser enforces it even with JS
 * off; this element only makes the limit visible, because silently refusing keystrokes at
 * the cap reads as a broken input.
 *
 * Markup contract — wrap the field and give it an output element:
 *   <bh-charcount>
 *     <textarea maxlength="300"></textarea>
 *     <span data-bh-count aria-live="polite">0 / 300</span>
 *   </bh-charcount>
 *
 * `.is-warning` lands at 85% of the limit, `.is-full` when there is no room left, matching the
 * .bh-char-count--warning / --limit states already used by the cake message field.
 */
class BhCharCount extends HTMLElement {
  connectedCallback() {
    this.field = this.querySelector('input[maxlength], textarea[maxlength]');
    this.output = this.querySelector('[data-bh-count]');
    if (!this.field || !this.output) return;
    this.max = parseInt(this.field.getAttribute('maxlength'), 10) || 0;
    this.field.addEventListener('input', () => this.update());
    this.update();
  }

  update() {
    const used = this.field.value.length;
    this.output.textContent = `${used} / ${this.max}`;
    this.output.classList.toggle('bh-char-count--warning', used >= this.max * 0.85 && used < this.max);
    this.output.classList.toggle('bh-char-count--limit', used >= this.max);
  }
}

if (!customElements.get('bh-charcount')) {
  customElements.define('bh-charcount', BhCharCount);
}
